import { useQuery } from "@tanstack/react-query";
import { getVideos } from "../../../api/endpoints/VideoEndpoints";

export default function useGetVideos() {
  return useQuery({
    queryKey: ["videos"],
    queryFn: () => getVideos(0, 10000),
  });
}
